import { useState, useEffect } from "react";

import { Container } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import TitlepicRegistration from "../../sections/TitlepicRegistration/TitlepicRegistration";
import Header from "../../sections/Header/Header";
import Trial from "../../sections/Bookfreetrial/Trial";
import Footer from "../../sections/Footer/Footer";

const Registration = () => {
  const initialValues = {
    username: "",
    email: "",
    phonenumber: "",
    country: "",
    course: "",
    plan: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    // console.log(formValues);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate(formValues));
    setIsSubmit(true);
  };
  
  useEffect(() => {
    console.log(formErrors);
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      // console.log(formValues);
    }
  }, [formErrors]);
  const validate = (values) => {
    const errors = {};
    const regex = /^[a-zA-Z0-9]+@+[a-zA-Z0-9]+.+[A-z]/;
    const numbregex =
    /^\d{11}$/;
    
    if (!values.username) {
      errors.username = "Username is required!";                  
    }
    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regex.test(values.email)) {
      errors.email = "This is not a valid email format!";
    }
    if (!values.phonenumber) {
      errors.phonenumber = "Phone Number is required!";
    } else if (!numbregex.test(values.phonenumber)) {
      errors.phonenumber = "This is not a valid phonenumber format!";
    }
    if (!values.country) {
      errors.country = "Add Your Country!";
    }
    if (!values.course) {
      errors.course = "Add Your Course!";
    }
    if (!values.plan) {
      errors.plan = "Add Your plan!";
    }
    return errors;
  };
  return (
    <div>
      <Header />
      <TitlepicRegistration />
      <div className="QL__PG__Registration">
        <Container>
         

          <Grid container spacing={8}>
            <Grid item xs={12} md={6}>
              <h1 className="HeadingAll pb-sm-5">Registration Form</h1>
              

              <form onSubmit={handleSubmit} className="Registrationform">
                <div className="QL__PG__Registration__form">
                  <div className="QL__PG__Registration__FormName">
                    <label htmlFor="username">Name:</label>
                  </div>

                  <input
                    className="QL__PG__Registration__formField"
                    value={formValues.username}
                    onChange={handleChange}
                    type="text"
                    name="username"
                    id="username"
                    placeholder="Enter name"
                  />
                </div>
                <div className="pt-2" style={{ color: "red" }}>
                  {formErrors.username}
                </div>
                <div className="QL__PG__Registration__form">
                  <div className="QL__PG__Registration__FormName">
                    <label htmlFor="email">Email:</label>
                  </div>

                  <input
                    className="QL__PG__Registration__formField"
                    value={formValues.email}
                    onChange={handleChange}
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Enter email"
                  />
                </div>
                <div className="pt-2" style={{ color: "red" }}>
                  {formErrors.email}
                </div>
                <div className="QL__PG__Registration__form">
                  <div className="QL__PG__Registration__FormName">
                    <label htmlFor="phone">Phone Number:</label>
                  </div>
                  <input
                    className="QL__PG__Registration__formField"
                    value={formValues.phonenumber}
                    type="number"
                    name="phonenumber"
                    id="phonenumber"
                    placeholder="Phone Number"
                    onChange={handleChange}
                  />
                </div>
                <div className="pt-2" style={{ color: "red" }}>
                  {formErrors.phonenumber}
                </div>
                <div className="QL__PG__Registration__form">
                  <div className="QL__PG__Registration__FormName">
                    <label htmlFor="country">Country:</label>
                  </div>

                  <input
                    value={formValues.country}
                    onChange={handleChange}
                    className="QL__PG__Registration__formField"
                    type="text"
                    name="country"
                    id="country"
                    placeholder="e.g. newyork"
                  />
                </div>
                <div className="pt-2" style={{ color: "red" }}>
                  {formErrors.country}
                </div>
                <div className="QL__PG__Registration__form">
                  <div className="QL__PG__Registration__FormName">
                    <label htmlFor="course">Course:</label>
                  </div>

                  <input
                    value={formValues.course}
                    className="QL__PG__Registration__formField"
                    type="text"
                    name="course"
                    id="course"
                    placeholder="e.g. Qur'an Memorization"
                    onChange={handleChange}
                  />
                </div>
                <div className="pt-2" style={{ color: "red" }}>
                  {formErrors.course}
                </div>
                <div className="QL__PG__Registration__form">
                  <div className="QL__PG__Registration__FormName">
                    <label htmlFor="plan">Plan:</label>
                  </div>

                  <input
                    value={formValues.plan}
                    className="QL__PG__Registration__formField"
                    type="text"
                    name="plan"
                    id="plan"
                    placeholder="e.g. Plan A"
                    onChange={handleChange}
                  />
                </div>

                <div className="pt-2" style={{ color: "red" }}>
                  {formErrors.plan}
                </div>
                <br />

                <div className="QL----Registration----SubmitButton">
                  <Button
                    type="submit"
                    className="QL__PG__Registration__buttons"
                    variant="contained"
                  >
                    Submit
                  </Button>
                </div>
              </form>
              {Object.keys(formErrors).length === 0 && isSubmit ? (
            <div style={{fontSize:22}} className="pt-5"> Submitted Successfully</div>
          ) : (
            <pre></pre>
          )}
            </Grid>
            <Grid item xs={12} md={6}>
              <h1 className="HeadingAll">Quran Learning Made Easier:</h1>
              <Typography paddingTop={8.5} fontWeight={400} fontSize={18}>
                -Convenience: No travel time required
              </Typography>
              <Typography fontWeight={400} fontSize={18} paddingTop={0.3}>
                -Choice: Hundreds of highly qualified Quran tutors
              </Typography>
              <Typography fontWeight={400} fontSize={18} paddingTop={0.3}>
                -Cost-effective: Tutor rates to suit all budgets
              </Typography>
              <Typography fontWeight={400} fontSize={18} paddingTop={0.3}>
                -Technology: Built-in tools to help you learn Quran
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </div>
      <Trial />
      <Footer />
    </div>
  );
};

export default Registration;
